<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>系统用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" ref="searchForm" inline>
        <el-form-item label="姓名：" prop="accountName" label-width="90px">
          <el-input clearable v-model="listParams.accountName" placeholder="姓名" />
        </el-form-item>
        <el-form-item label="账号：" prop="userName" label-width="90px">
          <el-input clearable v-model="listParams.userName" placeholder="账号" />
        </el-form-item>
        <el-form-item label=" ">
          <el-button @click="loadTableData" type="primary" size="small">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <section>
            <el-button type="primary" size="small" @click="handleAdd" class="mgr10">新增</el-button>
          </section>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="dataList" border>
        <el-table-column type="selection" width="55" />

        <el-table-column align="center" label="序号" width="60">
          <template slot-scope="scope">
            <span>
              {{ (pager.pageIndex - 1) * pager.pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="姓名" prop="accountName" />

        <el-table-column align="center" label="账号" prop="userName" />

        <el-table-column align="center" label="角色" prop="roleName" />

        <el-table-column align="center" label="状态" prop="status">
          <template slot-scope="scope">{{ scope.row.status === 0 ? "冻结" : "启用" }}</template>
          <template slot-scope="scope">
            <el-tag :type="formatSysUserTagType(scope.row.status)">{{ scope.row.status | formatSysUserType }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="创建时间" prop="createdTime" />

        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该用户？" @confirmed="handleDelete(scope.row.id)">
              <span class="color-danger">删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <SysUserDialog :dialogVisible.sync="sysUserDialogVisible" :id="sysUserId" @onSuccess="loadTableData()" />
  </div>
</template>

<script>
import SysUserDialog from "../components/SysUserDialog";

// 用户状态
const sysUserTypeList = [
  { label: "冻结", value: 0, tagType: "info" },
  { label: "启用", value: 1, tagType: "success" },
];

export default {
  components: {
    SysUserDialog,
  },
  filters: {
    formatSysUserType(type) {
      return sysUserTypeList.find(item => item.value == type).label;
    },
  },
  data() {
    return {
      tableLoading: false,
      listParams: {
        accountName: "",
        userName: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dataList: [],
      sysUserDialogVisible: false,
      sysUserId: "",
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    formatSysUserTagType(type) {
      return sysUserTypeList.find(item => item.value == type).tagType;
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/user/userList",
        method: "GET",
        params: this.listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dataList = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
              this.dataList = [];
            }

            this.tableLoading = false;
          } else {
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    handleAdd() {
      this.sysUserDialogVisible = true;
      this.sysUserId = "";
    },
    handleEdit(id) {
      this.sysUserDialogVisible = true;
      this.sysUserId = id;
    },
    handleDelete(id) {
      this.$http({
        url: global.apiUrl + `/user/deleteUser/${id}`,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>
<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
